import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import ProcessingTable from './table/ProcessingTable'
import UsedTable from './table/UsedTable'
import NormalTable from './table/NormalTable'

import { getCoupons, getCouponProcess } from '../../actions/asyncOrders'

import { PAGE_SIZE } from 'libraries/utils'

class CouponList extends Component {
    constructor() {
        super()
        this.state = {
            activeTab: 0,
            couponStatus: 'in-process',
            // in-process / available / used / expired
            // 尚未達成 / 可使用 / 已使用 / 已過期
        }
    }

    componentDidMount() {
        this.getCouponList(0)
    }

    onClickTab = (event, newValue) => {
        const newCouponStatus = event.currentTarget.id
        if (this.state.couponStatus !== newCouponStatus) {
            this.setState({
                activeTab: newValue,
                couponStatus: newCouponStatus,
            }, () => {
                this.getCouponList(0)
            })
        }
    }

    getCouponList = (pageIndex) => {
        const { couponStatus } = this.state
        this.props.getCoupons(couponStatus, pageIndex + 1, PAGE_SIZE)
        if(couponStatus === 'in-process'){
            this.props.getCouponProcess(pageIndex + 1, PAGE_SIZE)
        }
    }

    render() {
        const { t, couponProcessList, couponlist, isLoading } = this.props
        const { activeTab } = this.state
        return (
            <Grid container justify="center" className="main-contaienr">
                <Grid item md={8}>
                    <Tabs
                        value={activeTab}
                        onChange={this.onClickTab}
                        className="tabs"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label={t('in_process')} id="in-process" />
                        <Tab label={t('available')} id="available" />
                        <Tab label={t('used')} id="used" />
                        <Tab label={t('expired')} id="expired" />
                    </Tabs>
                    {activeTab === 0 &&
                        <ProcessingTable
                            isLoading={isLoading}
                            data={couponlist}
                            couponProcessList={couponProcessList}
                            onPageChange={this.getCouponList}
                        />
                    }
                    {activeTab === 1 && 
                        <NormalTable
                            isLoading={isLoading}
                            data={couponlist}
                            onPageChange={this.getCouponList}
                        />
                    }
                    {activeTab === 2 && 
                        <UsedTable
                            isLoading={isLoading}
                            data={couponlist}
                            onPageChange={this.getCouponList}
                        />
                    }
                    {activeTab === 3 &&
                        <NormalTable
                            isLoading={isLoading}
                            data={couponlist}
                            onPageChange={this.getCouponList}
                        />
                    }
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps = state => ({
    isLoading: state.orders.isLoading,
    couponlist: state.orders.coupons,
    couponProcessList: state.orders.couponProcessList,
})

const mapDispatchToProps = ({
    getCoupons,
    getCouponProcess,
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(CouponList))
